export const dashboardTimeIntervalOptions = [
  { value: "1w", label: "Last 7 days", days: 7 },
  { value: "2w", label: "Last 2 Weeks", days: 14 },
  { value: "1m", label: "Last 1 Month", days: 30 },
  { value: "3m", label: "Last 3 Months", days: 91 },
  { value: "6m", label: "Last 6 Months", days: 183 },
  { value: "12m", label: "Last 1 year", days: 365 },
];
